<template>
  <div
       class="fancy-order d-flex align-items-center ml-auto">

    <!-- Quantity pill -->
    <div class="qty-pill d-flex align-items-center">

      <!-- Minus -->
      <button
        class="icon-btn"
        @click="decrease"
        :disabled="quantity <= min"
      >
        <i class="fas fa-minus"></i>
      </button>

      <!-- Input -->
      <input
        :min="min"
        class="qty-input"
        v-model.number="quantity"
        @keyup.enter="emitAdd"
      />

      <!-- Plus -->
      <button
        class="icon-btn"
        @click="increase"
      >
        <i class="fas fa-plus"></i>
      </button>

    </div>

    <!-- Add to cart -->
    <b-button
      variant="success"
      class="cart-btn ml-2 d-flex align-items-center justify-content-center"
      @click="emitAdd"
      :disabled="loading"
    >
      <i v-if="!loading" class="fas fa-cart-plus"></i>
      <b-spinner v-else small></b-spinner>
    </b-button>

  </div>
</template>

<script>
export default {
  name: 'FancyQuantityCart',

  props: {
    value: {
      type: Number,
      default: 1
    },
    min: {
      type: Number,
      default: 1
    },
loading: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      quantity: this.value
    }
  },

  watch: {
    quantity (val) {
      this.$emit('input', val)
    },
    value (val) {
      this.quantity = val
    }
  },

  methods: {
    increase () {
      this.quantity++
    },
    decrease () {
      this.quantity = Math.max(this.min, this.quantity - 1)
    },
    emitAdd () {
      this.$emit('add', this.quantity)
    }
  }
}
</script>



<style>

  .fancy-order {
  gap: 8px;
}

/* Quantity pill */
.qty-pill {
  background: rgba(255, 255, 255, 0.85);
  border-radius: 999px;
  padding: 4px 6px;
  box-shadow: 0 6px 18px rgba(0,0,0,0.12);
  transition: all 0.25s ease;
}

.qty-pill:hover {
  box-shadow: 0 10px 24px rgba(0,0,0,0.18);
}

/* Input */
.qty-input {
  width: 42px;
  border: none;
  background: transparent;
  text-align: center;
  font-weight: 700;
  font-size: 14px;
  outline: none;
}

/* Icon buttons */
.icon-btn {
  border: none;
  background: transparent;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  color: #555;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.icon-btn:hover {
  background: #f1f3f5;
  color: #000;
  transform: scale(1.1);
}

/* Cart button */
.cart-btn {
  width: 38px;
  height: 38px;
  padding: 0;
  border-radius: 50%;
}

.cart-btn:disabled {
  opacity: 0.6;
  transform: none;
  box-shadow: none;
}

</style>